import * as Yup from 'yup';
import { find } from 'lodash';

export const validationSchema = Yup.object().shape({
  icdCode: Yup.string(),
  description: Yup.string()
});

export const initialValues = {
  icdCode: '',
  description: '',
}

export const type = [
  { kind: 'primary', id: 1 },
  { kind: 'secondary', id: 2 },
  { kind: 'tertiary', id: 3 },
  { kind: 'other', id: 4 },
]

export const kindName = (id) => {
  const list = find(type, { id });
  return list ? list.kind : false;
}

export const kindId = (name = '') => {
  const list = type.find(item => item.kind === name.toLowerCase());
  return list ? list.id : 4;
}

export const dataMock = [
    {
      id: '1',
      icdCode: '12345',
      version: '',
      description: 'Degeneres dolor inpsum lorem',
      kind: 1
    },
    {
      id: '2',
      icdCode: '12345',
      version: '2',
      description: 'Lorem ipsum dolor degeneres',
      kind: 1
    },
    {
      id: '3',
      icdCode: '123123',
      version: '3',
      description: 'degeneres',
      kind: 1
    },
    {
      id: '4',
      icdCode: '123123',
      version: '3',
      description: 'Esta es una descripcion bien large para que se pueda ellipsar con una libreria',
      kind: 1
    },
    {
      id: '5',
      icdCode: '12345',
      version: '3',
      description: 'Esta es una descripcion bien large para que se pueda ellipsar con una libreria',
      kind: 1
    },
    {
      id: '6',
      icdCode: ' NAOEWYR',
      version: '3',
      description: 'Esta es una descripcion bien large para que se pueda ellipsar con una libreria',
      kind: 1
    },
    {
      id: '7',
      icdCode: ' NAOEWYR',
      version: '3',
      description: ' large para que se pueda ellipsar con una libreria',
      kind: 1
    }
  ]